export default __webpack_public_path__ + "static/media/dots.22671d85.png";